import { render, staticRenderFns } from "./GroupOpenHome.vue?vue&type=template&id=26630954&scoped=true"
import script from "./GroupOpenHome.vue?vue&type=script&lang=js"
export * from "./GroupOpenHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26630954",
  null
  
)

export default component.exports